var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contact" } }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("message.contact.title")))]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.result,
            expression: "result"
          }
        ]
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.success,
                expression: "success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-success" }, [
              _vm._v(_vm._s(_vm.$t("message.contact.success")))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.success,
                expression: "!success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-warning" }, [
              _vm._v(_vm._s(_vm.$t("message.contact.error")))
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "lds-roller"
      },
      [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading && _vm.main,
            expression: "!loading && main"
          }
        ]
      },
      [
        _c(
          "section",
          [
            _c("p", [_vm._v(_vm._s(_vm.$t("message.contact.subject")))]),
            _vm._v(" "),
            _c("b-input", {
              model: {
                value: _vm.subject,
                callback: function($$v) {
                  _vm.subject = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "subject"
              }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("message.contact.email")))]),
            _vm._v(" "),
            _c("b-input", {
              attrs: { type: "email" },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "email"
              }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("message.contact.content")))]),
            _vm._v(" "),
            _c("b-input", {
              attrs: { type: "textarea" },
              model: {
                value: _vm.message,
                callback: function($$v) {
                  _vm.message = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "message"
              }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: {
                  click: function($event) {
                    _vm.exec()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("message.contact.send")))]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf6573c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf6573c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = null
// module chunks = 